module.exports = __webpack_public_path__ + "static/day13-bcf988a6a5d4f91f0fa687ada14bb006.png";